import React from "react"
import tw from "twin.macro"
import { YouTubeAccountDetails, Maybe } from "../../graphql/generated/graphql"
import { useTranslation } from "next-i18next"
import { getGoogleInstallationUrl } from "../../utils/google"
import { DateTime } from "luxon"
import { ReactComponent as YouTubeIcon } from "../../assets/profile/youTube-black.svg"
import { ReactComponent as GoogleSignInIcon } from "../../assets/social/google-signin.svg"
import { Button, ButtonTheme } from "../formElements/button"
import { Routes } from "../../routes"
import { useRouter } from "next/router"

interface YouTubeIntegrationProps {
  youTubeAccountDetails: Maybe<YouTubeAccountDetails | undefined>
  showIntegrations: boolean
}
export const YouTubeIntegration = ({ youTubeAccountDetails, showIntegrations }: YouTubeIntegrationProps) => {
  const { t } = useTranslation("profile")
  const router = useRouter()

  const { isLinked, questionCreatedCount, videoCrawlJobCount, latestQuestionCreatedAt } = youTubeAccountDetails ?? {
    isLinked: false,
    questionCreatedCount: 0,
    videoCrawlJobCount: 0,
    isChannelCrawlEnabled: false,
    latestQuestionCreatedAt: null,
    channelCrawlJobCreatedAt: null,
  }
  return (
    <div tw="text-center bg-[#FFC6C6] rounded-md p-4 space-y-3" css={showIntegrations ? tw`block` : tw`hidden`}>
      <div tw="flex items-center justify-center text-[24px] font-bold">
        <YouTubeIcon tw="mr-2" />
        {t("Integrations.youtube")}
      </div>
      <p
        css={"span {font-weight: bold}"}
        dangerouslySetInnerHTML={{
          __html: isLinked
            ? t("Integrations.youtube_videos", {
                videoCrawlJobCount,
                latestQuestionCreatedAt:
                  questionCreatedCount > 0 ? DateTime.fromISO(latestQuestionCreatedAt).toFormat("MM/dd/yy") : `-`,
              })
            : t("Integrations.youtube_what"),
        }}
      />

      {!isLinked ? (
        <div tw="flex items-center justify-center cursor-pointer">
          <GoogleSignInIcon
            onClick={() => {
              void router.push(getGoogleInstallationUrl())
            }}
          />
        </div>
      ) : (
        <Button
          twStyle={tw`disabled:(bg-[#f78080] hover:bg-[#f78080])`}
          theme={ButtonTheme.Warning}
          action={t("Integrations.manage_btn")}
          onClickAsync={async () => {
            await router.push({ pathname: Routes.YouTubeSettings })
          }}
        />
      )}
    </div>
  )
}
